import { Input, InputProps } from 'antd';

function applyCNPJMask(value: string): string {
  const raw = value
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()
    .slice(0, 14);
  if (raw.length <= 2) return raw;
  if (raw.length <= 5) return `${raw.slice(0, 2)}.${raw.slice(2)}`;
  if (raw.length <= 8) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5)}`;
  if (raw.length <= 12)
    return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8)}`;
  return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(
    12
  )}`;
}

type CNPJInputProps = Omit<InputProps, 'value' | 'onChange' | 'maxLength'> & {
  value?: string;
  onChange?: (val: string) => void;
};

function CNPJInput({ value, onChange, ...rest }: CNPJInputProps) {
  return (
    <Input
      {...rest}
      value={value ?? ''}
      onChange={(e) => onChange?.(applyCNPJMask(e.target.value))}
      maxLength={18}
    />
  );
}

export default CNPJInput;
